'use client';

import { useEffect, useRef } from 'react';

import { usePathname } from 'next/navigation';

import { trackTikTokPageView } from '@/lib/analytics/tiktok';

export default function TikTokPageview() {
  const pathname = usePathname();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current === pathname) return;

    previousPathname.current = pathname;
    trackTikTokPageView();
  }, [pathname]);

  return null;
}
